<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <h4 class="card-title ">Editar</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.status != '', 'has-danger' : validation.status != '' }">
                                        <label for="name" class="bmd-label-floating">Nome *</label>
                                        <input refs="name" type="text" class="form-control" v-model="form.status" />
                                        <label v-if="validation.status != ''" id="name-error" class="error" for="name">{{ validation.status }}</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group"
                                         v-bind:class="{'is-filled': form.term != '', 'has-danger' : validation.term != '' }">
                                        <label for="term" class="bmd-label-floating">Dias *</label>
                                        <input refs="term" type="text" class="form-control" v-model="form.term" />
                                        <label v-if="validation.term != ''" id="term-error" class="error" for="term">{{ validation.term }}</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.color != '', 'has-danger' : validation.color != '' }">
                                        <label for="color" class="bmd-label-floating">Cor *</label>
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.color != '', 'has-danger' : validation.color != '' }">
                                        <select v-bind:style="{ color: form.color || '#000'}" style="padding-left: 5px;border-top: 1px solid #cccccc;border-left: 1px solid #cccccc;border-right: 1px solid #cccccc" placeholder="Cor" v-model="form.color" class="form-control">
                                            <option value="red">Vermelho</option>
                                            <option value="orange">Laranja</option>
                                            <option value="yellow">Amarelo</option>
                                            <option value="green">Verde</option>
                                            <option value="blue">Azul</option>
                                            <option value="purple">Roxo</option>
                                        </select>
                                        <br clear="all">
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.color != '', 'has-danger' : validation.color != '' }">
                                        <label v-if="validation.color != ''" id="color-error" class="error" for="responsible">{{ validation.color }}</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.disable_lead != '', 'has-danger' : validation.disable_lead != '' }">
                                        <label for="disable_lead" class="bmd-label-floating">Desabilita o Lead? *</label>
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.disable_lead != '', 'has-danger' : validation.disable_lead != '' }">
                                        <select style="padding-left: 5px;border-top: 1px solid #cccccc;border-left: 1px solid #cccccc;border-right: 1px solid #cccccc" placeholder="Desabilita Lead" v-model="form.disable_lead" class="form-control">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                        <br clear="all">
                                    </div>
                                    <div class="form-group"
                                         v-bind:class="{'is-filled': form.disable_lead != '', 'has-danger' : validation.disable_lead != '' }">
                                        <label v-if="validation.disable_lead != ''" id="color-error" class="error" for="disable_lead">{{ validation.disable_lead }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons
                                v-bind:to-back="{name: 'leads.status.index'}"
                                text-back="Voltar"
                                icon-back="keyboard_arrow_left" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        computed: {
            form: {
                set(_fuel) {

                },
                get() {
                    return this.$store.state.lead_status.item;
                }
            }
        },
        created() {
            this.getData();
        },
        data() {
            return {
                validation: {
                    status: '',
                    color: '',
                    term: '',
                    disable_lead: 0
                }
            };
        },
        methods: {
            onSubmit(_ev) {
                var valid = true;
                var self = this;

                self.validation.status = '';
                self.validation.color = '';
                self.validation.term = '';

                if (self.form.status == '') {
                    self.validation.status = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.color == '') {
                    self.validation.color = 'Campo obrigatório!';
                    valid = false;
                }

                self.form.term = self.form.term.replace(/[^0-9.]/g, "");
                if (self.form.term == '') {
                    self.validation.term = 'Campo obrigatório!';
                    valid = false;
                }

                self.form.disable_lead = parseInt(self.form.disable_lead);

                if (isNaN(self.form.disable_lead)) {
                    self.validation.disable_lead = 'Campo obrigatório!';
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit('onLoading');

                    const response = self.$store.dispatch('lead_status/edit', this.form);

                    response.then(function () {
                        self.$root.$emit('onLoading');
                        self.$notify.success("Status atualizado com sucesso!");
                        self.$router.push({'name': 'leads.status.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit('onLoading');
                        if (err.status === 422) {
                            if (err.data.errors.status !== undefined) {
                                self.validation.status = err.data.errors.status[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('lead_status/get', this.$route.params.id);

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.$router.push({'name': 'leads.status.index'});
                });
            }
        }
    };
</script>
